import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ActivityIndicator, WingBlank} from "antd-mobile";
import ClaimService from "../../apiServices/ClaimService";
import {List, Icon} from "antd";
import * as helper from '../../utils/helper';

class ClaimList extends Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            claims: null,
            showLoading: true,
        };
    }

    componentDidMount() {
        ClaimService.list().then(response => {
            this.setState({claims: response.data, showLoading: false});
        }).catch(function(error){
            console.log(error);
        });
    }

    claimDetail = (object_id) => {
        this.props.history.push('/chi-tiet-khieu-nai?id='+object_id);
    };

    render() {
        if (this.state.showLoading===true) {
            return (<div className="wrap-content"><ActivityIndicator toast text="Loading..." animating={this.state.showLoading}/></div>);
        }else if (this.state.claims===null) {
            return (
                <div style={{backgroundColor: '#FFFFFF', height: '100%', textAlign: 'center'}}>
                    <WingBlank size="md" className='text-center'>
                        <div style={{paddingTop: 60, color: '#000000'}}>Bạn chưa có Yêu cầu bồi thường</div>
                    </WingBlank>
                    <WingBlank size="md" className='text-center'>
                        <img style={{width: '25%'}} src={require('../../resources/images/icons/car-service.svg')} alt=""/>
                    </WingBlank>
                    <div className='boxBuyNow'>
                        <Link to='/yeu-cau-boi-thuong' className="ant-btn btn-next-action" style={{padding: '10px 40px'}}>Tạo Yêu cầu bồi thường</Link>
                    </div>
                </div>
            );
        } else {
            return (
                <div style={{padding: '0 15px'}}>
                    <List
                        itemLayout="horizontal"
                        dataSource={this.state.claims}
                        renderItem={item => (
                            <List.Item key={item.id} className='listClaims' onClick={() => this.claimDetail(item.id)}>
                                <div className='claimItemBox'>
                                    <div className='plateNumberBox'>
                                        <p className='carPlateNumber'>{item.user_car.plate_number}</p>
                                        <p className='carProd'>{item.car_product.name}</p>
                                    </div>
                                    <div className='detailClaimBox'>
                                        <div className='topClaimContent'>
                                            <Icon type="clock-circle" /> {helper.formatDate2(item.created_at, true)}
                                        </div>
                                        <div style={{margin: '5px 0'}}>
                                            <Icon type={'profile'}/> {item.description.substring(0, 30)+"..."}
                                        </div>
                                        <div className='claimStatBox'>
                                            <Icon type="info-circle" /> {item.claim_stat}
                                        </div>
                                    </div>
                                    <div className='clearFix'></div>
                                </div>
                            </List.Item>
                        )}
                    />
                    <div className='boxBuyNow' style={{marginTop: '10px'}}>
                        <Link to='/yeu-cau-boi-thuong' className="ant-btn btnCreateClaim">Tạo Yêu cầu bồi thường</Link>
                    </div>
                </div>
            );
        }
    }
}

export default (withTranslation())(ClaimList);